import ProduitEcranCible from "../../domain/ProduitEcranCible";

export const boomers = new ProduitEcranCible('ctb', 'Cine Target Boomers CSP+', 'Entrées Boomers CSP+', {
  'S2001': {audience: 114854, tarif: 96710},
  'S2002': {audience: 73977, tarif: 40490},
  'S2003': {audience: 87580, tarif: 47930},
  'S2004': {audience: 103845, tarif: 56830},
  'S2005': {audience: 159054, tarif: 154010},
  'S2006': {audience: 167040, tarif: 168780},
  'S2007': {audience: 211186, tarif: 231160},
  'S2008': {audience: 208275, tarif: 227980},
  'S2009': {audience: 126347, tarif: 117020},
  'S2010': {audience: 140642, tarif: 130260},
  'S2011': {audience: 109396, tarif: 82900},
  'S2012': {audience: 91980, tarif: 69700},
  'S2013': {audience: 102213, tarif: 86060},
  'S2014': {audience: 83330, tarif: 80690},
  'S2015': {audience: 111226, tarif: 107700},
  'S2016': {audience: 129192, tarif: 125100},
  'S2017': {audience: 158473, tarif: 173460},
  'S2018': {audience: 115166, tarif: 101820},
  'S2019': {audience: 92102, tarif: 69790},
  'S2020': {audience: 95065, tarif: 72040},
  'S2021': {audience: 116970, tarif: 108340},
  'S2022': {audience: 95811, tarif: 84710},
  'S2023': {audience: 111210, tarif: 93640},
  'S2024': {audience: 96733, tarif: 65160},
  'S2025': {audience: 89202, tarif: 60090},
  'S2026': {audience: 99247, tarif: 142060},
  'S2027': {audience: 146770, tarif: 160650},
  'S2028': {audience: 106883, tarif: 99000},
  'S2029': {audience: 107787, tarif: 108910},
  'S2030': {audience: 122496, tarif: 103140},
  'S2031': {audience: 95040, tarif: 80020},
  'S2032': {audience: 114563, tarif: 96460},
  'S2033': {audience: 106734, tarif: 89870},
  'S2034': {audience: 91190, tarif: 49910},
  'S2035': {audience: 110497, tarif: 65130},
  'S2036': {audience: 116836, tarif: 98380},
  'S2037': {audience: 91004, tarif: 80460},
  'S2038': {audience: 105493, tarif: 106590},
  'S2039': {audience: 99063, tarif: 100090},
  'S2040': {audience: 101656, tarif: 85590},
  'S2041': {audience: 115247, tarif: 97040},
  'S2042': {audience: 135107, tarif: 136510},
  'S2043': {audience: 128210, tarif: 140340},
  'S2044': {audience: 141666, tarif: 143140},
  'S2045': {audience: 134588, tarif: 124660},
  'S2046': {audience: 136521, tarif: 132190},
  'S2047': {audience: 119084, tarif: 115310},
  'S2048': {audience: 131852, tarif: 127670},
  'S2049': {audience: 121794, tarif: 153830},
  'S2050': {audience: 130428, tarif: 175710},
  'S2051': {audience: 163335, tarif: 226920},
  'S2052': {audience: 187532, tarif: 260540}
});

